export const CASE_TYPE = {
  CASE_1: 'CASE_1',
  CASE_2: 'CASE_2',
  CASE_3: 'CASE_3',
  CASE_4: 'CASE_4',
  CASE_5: 'CASE_5',
};
